module.exports = __webpack_public_path__ + "assets/img/home_cs_4.4e12c2eb.png";